export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/imageUtil.worker.c4587961.worker.js");
}
